import {
  GET_TRANSACTIONS,
  GET_DETAIL,
  SET_LOADING,
  GET_REFERENCE_DATA,
} from '../types/transaction';

export function getTransactions(params) {
  return {
    type: GET_TRANSACTIONS,
    params,
  };
}

export function getTransactionDetail(params) {
  return {
    type: GET_DETAIL,
    params,
  };
}

export function setLoading(isLoading = false) {
  return {
    type: SET_LOADING,
    isLoading,
  };
}

export function getReferenceData(params) {
  return {
    type: GET_REFERENCE_DATA,
    params,
  };
}
